(function () {
  /** `.cus-collection__card` sets `display:flex`, which overrides the `[hidden]` attribute. */
  const SEARCH_HIDDEN_CLASS = 'cus-collection__card--search-hidden';
  const AI_HIDDEN_CLASS = 'cus-collection__card--ai-hidden';
  const AI_HIGHLIGHT_CLASS = 'cus-collection__card--ai-highlight';

  const SORT_SELECT = '[data-cus-collection-sort]';

    /** @type {Set<string>|null} Product handles allowed while AI search is active; `null` = AI off. */
  let aiMatchedHandles = null;

  /** @type {Map<string, number>|null} Per-handle AI score, so matches sort best-first, not just matched-first. */
  let aiMatchScores = null;



  /** Client-only sorts; fetched as `manual` then reordered in the DOM */
  const CLIENT_SORT_IDS = /** @type {const} */ (['cus-on-sale-first', 'cus-fastest-delivery']);

  const SELECTORS = {
    root: '[data-collection-filter-root]',
    collectionWrapper: '.cus-collection__wrapper',
    empty: '[data-cus-collection-empty]',
    section: '.custom-collection[data-section-id]',
    grid: '.cus-collection__grid',
    cards: '.cus-collection__card',
    count: '.custom-collection__count b',
    searchInput: '.hb-search-box input',
    productTitle: '.cus-collection__product-title',
    productDesc: '.cus-collection__product-desc',
  };

  function getSectionElements() {
    const sectionEl = document.querySelector(SELECTORS.section);
    if (!sectionEl) return null;

    const sectionId = sectionEl.dataset.sectionId;
    const wrapper = sectionEl.querySelector(SELECTORS.collectionWrapper);
    if (!sectionId || !wrapper) return null;

    return { sectionId, wrapper };
  }

  /** Show empty message when zero cards remain (tag fetch, sale filter, search, etc.). */
  function syncCollectionEmptyState(wrapper) {
    const grid = wrapper.querySelector(SELECTORS.grid);
    const empty = wrapper.querySelector(SELECTORS.empty);
    if (!grid || !empty) return;

    const visibleSelector = `${SELECTORS.cards}:not(.${SEARCH_HIDDEN_CLASS}):not(.${AI_HIDDEN_CLASS})`;
    const showEmpty = grid.querySelectorAll(visibleSelector).length === 0;

    empty.classList.toggle('cus-collection__empty--visible', showEmpty);
    grid.classList.toggle('cus-collection__grid--hide-for-empty', showEmpty);
  }

  function normalizeCollectionPath(raw) {
    const p = (raw ?? '').trim();
    if (!p) return '';
    const withSlash = p.startsWith('/') ? p : `/${p}`;
    return withSlash.replace(/\/+$/, '') || '/';
  }

  function resolveActiveCollectionPath(root) {
    return (
      normalizeCollectionPath(root?.dataset?.currentCollectionPath) ||
      normalizeCollectionPath(root?.dataset?.baseCollectionPath) ||
      normalizeCollectionPath(window.location.pathname)
    );
  }

  /** @param pathname Collection URL path (same one used by section AJAX; unchanged in address bar). */
  function ensureRootPathState(root, pathname) {
    if (pathname) root.dataset.currentCollectionPath = pathname;
  }

  function getCurrentSortValue(root) {
    const { wrapper } = getSectionElements() ?? {};
    return wrapper?.querySelector(SORT_SELECT)?.value ?? 'manual';
  }

  function shopifySortForRequest(sortVal) {
    if (CLIENT_SORT_IDS.includes(sortVal)) return 'manual';
    return sortVal || 'manual';
  }

  function buildFetchUrl(pathname, sectionId, sortVal) {
    const url = new URL(pathname, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('sort_by', shopifySortForRequest(sortVal));
    return url.toString();
  }

  function parseSectionHtml(htmlText) {
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');
    return doc.querySelector(SELECTORS.collectionWrapper);
  }

  function applySaleFilter(wrapper) {
    const grid = wrapper.querySelector(SELECTORS.grid);
    if (!grid) return;

    let visible = 0;
    grid.querySelectorAll(SELECTORS.cards).forEach((card) => {
      if (card.classList.contains('cus-collection__card--on-sale')) {
        visible += 1;
      } else {
        card.remove();
      }
    });

    const countEl = wrapper.querySelector(SELECTORS.count);
    if (countEl) countEl.textContent = String(visible);
  }

  function deliverySortKey(text) {
    const m = String(text ?? '').match(/(\d+)/);
    if (!m) return Number.POSITIVE_INFINITY;
    return Number.parseInt(m[1], 10);
  }

  function applyClientSort(wrapper, sortValue) {
    if (!CLIENT_SORT_IDS.includes(sortValue)) return;

    const grid = wrapper.querySelector(SELECTORS.grid);
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(SELECTORS.cards));

    cards.sort((a, b) => {
      if (sortValue === 'cus-on-sale-first') {
        const sa = a.classList.contains('cus-collection__card--on-sale');
        const sb = b.classList.contains('cus-collection__card--on-sale');
        if (sa === sb) return 0;
        return sa ? -1 : 1;
      }

      const ka = deliverySortKey(a.querySelector('.cus-collection__card-delivery')?.textContent);
      const kb = deliverySortKey(b.querySelector('.cus-collection__card-delivery')?.textContent);
      return ka - kb;
    });

    cards.forEach((card) => grid.appendChild(card));
  }

  function setActiveFilter(root, activeEl) {
    root.querySelectorAll('.hb-tab, [js-sale-tag]').forEach((el) => el.classList.remove('active'));
    activeEl.classList.add('active');
  }

  function getAiActive() {
    return aiMatchedHandles !== null;
  }

    function clearAiMatches() {
    aiMatchedHandles = null;
    aiMatchScores = null;
    const ctx = getSectionElements();
    if (ctx) {
      ctx.wrapper.querySelectorAll(SELECTORS.cards).forEach((card) => {
        card.classList.remove(AI_HIDDEN_CLASS, AI_HIGHLIGHT_CLASS);
      });
      recomputeCardVisibility(ctx.wrapper);
    }
  }

    function setAiMatches(handleSet, scores) {
    if (handleSet === null || handleSet === undefined) {
      aiMatchedHandles = null;
      aiMatchScores = null;
    } else {
      aiMatchedHandles = handleSet instanceof Set ? new Set(handleSet) : new Set(handleSet);
      aiMatchScores = scores instanceof Map ? scores : null;
    }
    const ctx = getSectionElements();
    if (ctx) recomputeCardVisibility(ctx.wrapper);
  }

  /**
   * Text filter (toolbar) × AI filter × sale/tag scope (DOM already reflects tag fetch).
   * @param {HTMLElement} wrapper
   */
  function recomputeCardVisibility(wrapper) {
    const grid = wrapper.querySelector(SELECTORS.grid);
    if (!grid) {
      syncCollectionEmptyState(wrapper);
      return;
    }

    const cards = grid.querySelectorAll(SELECTORS.cards);
    const root = document.querySelector(SELECTORS.root);
    const q = (root?.querySelector(SELECTORS.searchInput)?.value ?? '').trim().toLowerCase();
    const countEl = wrapper.querySelector(SELECTORS.count);
    const aiOn = aiMatchedHandles !== null;

    let visible = 0;

    cards.forEach((card) => {
      const handle = card.dataset.productHandle ?? '';
      const aiOk = !aiOn || (handle && aiMatchedHandles.has(handle));

      const corpusAttr = card.getAttribute('data-hb-ai-search-text');
      const corpus =
        corpusAttr != null && corpusAttr !== ''
          ? corpusAttr.toLowerCase()
          : [
              card.querySelector(SELECTORS.productTitle)?.textContent ?? '',
              card.querySelector(SELECTORS.productDesc)?.textContent ?? '',
              ...[...card.querySelectorAll('.cus-collection__product-tags')].map((el) => el.textContent ?? ''),
            ]
              .join(' ')
              .toLowerCase();

      const txtOk = !q || corpus.includes(q);

      card.classList.toggle(AI_HIDDEN_CLASS, aiOn && !aiOk);
      card.classList.toggle(SEARCH_HIDDEN_CLASS, !!q && !txtOk);
      card.classList.toggle(AI_HIGHLIGHT_CLASS, aiOn && aiOk);

      const shown =
        !card.classList.contains(SEARCH_HIDDEN_CLASS) &&
        !card.classList.contains(AI_HIDDEN_CLASS);
      if (shown) visible += 1;
    });

    if (countEl) countEl.textContent = String(visible);
    syncCollectionEmptyState(wrapper);
  }

  function applySearchToWrapper(wrapper, queryRaw) {
    void queryRaw;
    recomputeCardVisibility(wrapper);
  }

  /** Search only within cards already in `wrapper` (current tag / sale scope). */
  function applyCollectionSearchFromInput(root) {
    const ctx = getSectionElements();
    if (!ctx) return;

    const input = root.querySelector(SELECTORS.searchInput);
    applySearchToWrapper(ctx.wrapper, input?.value ?? '');
  }

  /** After Shopify HTML lands: optionally sale-strip, client sort, then search. */
  function finishCollectionRefresh(root, wrapper) {
    if (root.querySelector('[js-sale-tag].active')) {
      applySaleFilter(wrapper);
    }
    applyClientSort(wrapper, getCurrentSortValue(root));
    applyCollectionSearchFromInput(root);
  }

  let inflight = null;
  let filterLoadSeq = 0;

  /**
   * @param preserveSortVal Use when the markup is about to be replaced before we can read the select (e.g. sort change).
   */
  function fetchAndRenderCollection(root, pathname, preserveSortVal) {
    const ctx = getSectionElements();
    if (!ctx) return;

    const { sectionId, wrapper } = ctx;
    const normalizedPath = normalizeCollectionPath(pathname);
    if (!normalizedPath) return;

    const sortVal = preserveSortVal ?? getCurrentSortValue(root);

    inflight?.abort?.();
    inflight = new AbortController();

    filterLoadSeq += 1;
    const seq = filterLoadSeq;
    wrapper.classList.add('loading');

    fetch(buildFetchUrl(normalizedPath, sectionId, sortVal), { signal: inflight.signal })
      .then((r) => r.text())
      .then((text) => {
        const incoming = parseSectionHtml(text);
        if (!incoming) return;

        wrapper.innerHTML = incoming.innerHTML;

        const sel = wrapper.querySelector(SORT_SELECT);
        if (sel) sel.value = sortVal;

        ensureRootPathState(root, normalizedPath);

        const needAiReapply = aiMatchedHandles !== null;
        aiMatchedHandles = null;

        finishCollectionRefresh(root, wrapper);

        document.dispatchEvent(
          new CustomEvent('hb-collection-dom-refreshed', {
            bubbles: true,
            detail: { needAiReapply },
          }),
        );

      })
      .catch((err) => {
        if (err.name !== 'AbortError') console.error(err);
      })
      .finally(() => {
        if (seq === filterLoadSeq) {
          wrapper.classList.remove('loading');
        }
      });
  }

  /** Smoothly bring the services list up to just below the header + tab bar. */
  function scrollToResults() {
    const ctx = getSectionElements();
    if (!ctx) return;
    if (window.BzScroll) {
      // gap 0: the tab bar sits flush on the header and the list flush under it
      window.BzScroll.to(ctx.wrapper, { gap: 0 });
    } else {
      ctx.wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /**
   * @param opts.scroll false for programmatic clicks (AI search, quiz, "browse all"),
   *   which handle their own scrolling.
   */
  function activateFilter(root, trigger, opts) {
    const ctx = getSectionElements();
    if (!ctx) return;

    const basePathRaw = root.dataset.baseCollectionPath;
    if (!basePathRaw) return;

    const basePath = basePathRaw.replace(/\/+$/, '');
    const basePathNormalized = basePath.startsWith('/') ? basePath : `/${basePath}`;

    let pathname;
    if (trigger.hasAttribute('js-all') || trigger.hasAttribute('js-sale-tag')) {
      pathname = basePathNormalized;
    } else if (trigger.hasAttribute('js-product-tags')) {
      const tagHandle = trigger.dataset.tagHandle;
      if (!tagHandle) return;
      pathname = `${basePathNormalized}/${encodeURIComponent(tagHandle)}`;
    } else {
      return;
    }

    setActiveFilter(root, trigger);

   // if (!trigger.hasAttribute('js-all')) {
      window.HbCollectionFilter?.clearAiSearch?.();
   // }

    // Scroll right away (not after the fetch) so the click feels instant; the
    // list's top edge does not move when its cards are swapped.
    if (opts?.scroll !== false) scrollToResults();

    fetchAndRenderCollection(root, pathname);
  }

  document.addEventListener('click', (e) => {
    const browse = e.target.closest('[js-browse-all]');
    if (browse) {
      const filterRoot = document.querySelector(SELECTORS.root);
      if (!filterRoot) return;
      e.preventDefault();
      const input = filterRoot.querySelector(SELECTORS.searchInput);
      if (input) input.value = '';
      window.HbCollectionFilter?.clearAiSearch?.();
      filterRoot.querySelector('[js-all]')?.click();
      return;
    }

    const trigger = e.target.closest('[js-all], [js-product-tags], [js-sale-tag]');
    if (!trigger) return;

    const root = trigger.closest(SELECTORS.root);
    if (!root) return;

    e.preventDefault();

    // Only real visitor clicks scroll; .click() calls from other scripts don't.
    activateFilter(root, trigger, { scroll: e.isTrusted });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const trigger = e.target.closest('[js-sale-tag]');
    if (!trigger) return;

    const root = trigger.closest(SELECTORS.root);
    if (!root) return;

    e.preventDefault();
    activateFilter(root, trigger);
  });

  document.addEventListener('input', (e) => {
    const root = e.target.closest(SELECTORS.root);
    const searchWrap = root?.querySelector('.hb-search-box');
    if (!root || !searchWrap || !searchWrap.contains(e.target)) return;

    applyCollectionSearchFromInput(root);
  });

  document.addEventListener('change', (e) => {
    const select = e.target.closest(SORT_SELECT);
    if (!select) return;

    const root = document.querySelector(SELECTORS.root);
    if (!root) return;

    const pathname = resolveActiveCollectionPath(root);
    if (!pathname) return;

    fetchAndRenderCollection(root, pathname, select.value);
  });

  const ctxInit = getSectionElements();
  const rootInit = document.querySelector(SELECTORS.root);
  if (rootInit && !rootInit.dataset.currentCollectionPath) {
    rootInit.dataset.currentCollectionPath = normalizeCollectionPath(window.location.pathname);
  }
  function tryApplyFilterFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('hb_search') !== 'filter') return;
    const q = (params.get('q') || '').trim();
    if (!q) return;
    const root = document.querySelector(SELECTORS.root);
    const input = root?.querySelector(SELECTORS.searchInput);
    if (!root || !input) return;
    input.value = q;
    applyCollectionSearchFromInput(root);
  }

  if (ctxInit && rootInit) {
    applyClientSort(ctxInit.wrapper, getCurrentSortValue(rootInit));
    applyCollectionSearchFromInput(rootInit);
    tryApplyFilterFromUrl();
  } else if (ctxInit) {
    syncCollectionEmptyState(ctxInit.wrapper);
  }

    function sortAiMatchesFirst() {
    const ctx = getSectionElements();
    if (!ctx || aiMatchedHandles === null) return;

    const grid = ctx.wrapper.querySelector(SELECTORS.grid);
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(SELECTORS.cards));
    cards.sort((a, b) => {
      const handleA = a.dataset.productHandle ?? '';
      const handleB = b.dataset.productHandle ?? '';
      const ha = aiMatchedHandles.has(handleA);
      const hb = aiMatchedHandles.has(handleB);
      if (ha !== hb) return ha ? -1 : 1;
      if (ha && aiMatchScores) {
        const sa = aiMatchScores.get(handleA) ?? 0;
        const sb = aiMatchScores.get(handleB) ?? 0;
        if (sa !== sb) return sb - sa;
      }
      return 0;
    });
    cards.forEach((card) => grid.appendChild(card));
  }

  window.HbCollectionFilter = {
    getAiActive,
    setAiMatches,
    clearAiMatches,
    sortAiMatchesFirst,
    /** Alias for banner AI bar + browse-all reset */
    scrollToResults,
    clearAiSearch() {
      clearAiMatches();
      document.dispatchEvent(new CustomEvent('hb-ai-search-cleared', { bubbles: true }));
    },
    recomputeCardVisibilityFromRoot() {
      const ctx = getSectionElements();
      if (ctx) recomputeCardVisibility(ctx.wrapper);
    },
  };
})();
